import { Card, Row, Col, Table } from "react-bootstrap";
import {
  MOTHER_PATIENT,
  EMAIL,
  DOB,
  CURRENT_GESTATION,
  PRE_PREGNANCY_WEIGHT,
  HEIGHT,
  URN,
  MOBILE_NUMBER,
  SELECTED_PARTICIPANT,
  NAME,
  DUE_DATE,
  WEEK,
  BIRTH_PLACE,
  DIABETES_TYPE,
  STUDY_ID,
  RANDOMISED_DATE,
} from "../util/const";
import { Participant } from "../types/participant";
import { Patient } from "../types/patient";
import { FormatDateForDisplay } from "../util/data-utils";

interface InfoCardProps {
  participant: Participant;
  patient: Patient;
}

const InfoCards = ({ participant, patient }: InfoCardProps) => {
  
  const checkNameMatch = (parName: string, patName: string) => {
    if(parName === undefined || patName === undefined)
      return <i className="bi bi-x icon-x fs-4"></i>;

    if (parName.toLowerCase() === patName.toLowerCase()) {
      return <i className="bi bi-check icon-check fs-4"></i>;
    } else {
      return <i className="bi bi-x icon-x fs-4"></i>;
    }
  };

  const checkDobMatch = (parDob: string, patDob: string) => {
    if(parDob === undefined || patDob === undefined)
      return <i className="bi bi-x icon-x fs-4"></i>;

    if (Date.parse(parDob) === Date.parse(patDob)) {
      return <i className="bi bi-check icon-check fs-4"></i>;
    } else {
      return <i className="bi bi-x icon-x fs-4"></i>;
    }
  };

  return (
    <Row>
      <Col>
        <Card className="info-card">
          <Card.Header className="fs-6">
            <Row>
              <Col>{SELECTED_PARTICIPANT}</Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Table striped>
              <tbody>
                <tr>
                  <td>{NAME}:</td>
                  <td>
                    {participant.givenName} 
                    {checkNameMatch(
                      participant.givenName,
                      patient.givenNames.toString(),
                    )}
                    {participant.familyName}
                    {checkNameMatch(
                      participant.familyName,
                      patient.familyName
                    )}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>{DOB}:</td>
                  <td>
                    {FormatDateForDisplay(participant.birthDate)}
                    {checkDobMatch(participant.birthDate, patient.birthDate)}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>{DUE_DATE}:</td>
                  <td>{FormatDateForDisplay(participant.dueDate)}</td>
                  <td>{CURRENT_GESTATION}:</td>
                  <td>
                    {participant.weeksPregnant} {WEEK}s
                  </td>
                </tr>
                <tr>
                  <td>{HEIGHT}:</td>
                  <td>{participant.height}</td>
                  <td>{PRE_PREGNANCY_WEIGHT}:</td>
                  <td>{participant.prePregnancyWeight}</td>
                </tr>
                <tr>
                  <td>{EMAIL}:</td>
                  <td>{participant.email}</td>
                  <td>{MOBILE_NUMBER}:</td>
                  <td></td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card className="info-card">
          <Card.Header className="fs-6">
            <Row>
              <Col>{MOTHER_PATIENT}</Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <Table striped>
              <tbody>
                <tr>
                  <td className="fs-6">{NAME}:</td>
                  <td>
                    {patient.salutation} {patient.givenNames} 
                    {checkNameMatch(
                      participant.givenName,
                      patient.givenNames.toString(),
                    )}
                    {patient.familyName}
                    {checkNameMatch(
                      participant.familyName,
                      patient.familyName
                    )}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td>{DOB}:</td>
                  <td>
                    {FormatDateForDisplay(patient.birthDate)}
                    {checkDobMatch(participant.birthDate, patient.birthDate)}
                  </td>
                  <td>{BIRTH_PLACE}:</td>
                  <td>{patient.birthPlace}</td>
                </tr>
                <tr>
                  <td>{DUE_DATE}:</td>
                  <td>{FormatDateForDisplay(patient.dueDate)}</td>
                  <td>{CURRENT_GESTATION}:</td>
                  <td>
                    {patient.currentGestation} {WEEK}s
                  </td>
                </tr>
                <tr>
                  <td>{HEIGHT}:</td>
                  <td>{patient.height}</td>
                  <td>{PRE_PREGNANCY_WEIGHT}:</td>
                  <td>{patient.weight}</td>
                </tr>
                <tr>
                  <td>{EMAIL}:</td>
                  <td>{patient.email}</td>
                  <td>{MOBILE_NUMBER}:</td>
                  <td>{patient.phone}</td>
                </tr>
                <tr>
                  <td>{URN}:</td>
                  <td>{patient.urn}</td>
                  <td>{DIABETES_TYPE}:</td>
                  <td>{patient.diabetesType}</td>
                </tr>
                <tr>
                  <td>{STUDY_ID}:</td>
                  <td>{patient.studyId}</td>
                  <td>{RANDOMISED_DATE}:</td>
                  <td>{FormatDateForDisplay(patient.randomisedDate)}</td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default InfoCards;
